import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
// import { LoaderComponent } from "../../../Common/LoaderComponent";
import Swal from "sweetalert2";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const res = await Http.get(`/requisition-art`);
      const resRole = await Http.get(`/staff-type-check`);
      setReceiveData(res.data);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };
  const cols = [
    { field: "receipt_no", header: "Req. No." },
    { field: "date", header: "Date" },
    { field: "expected_time", header: "Time" },
    { field: "from_department.name", header: "From" },
    { field: "to_department.name", header: "To" },
    // { field: "created_by.name", header: "Created by" },
    // { field: "created_by.name", header: "Created by" },
    // ...(role === "mould" ||
    // role === "dstore" ||
    // role === "sagger" ||
    // role === "pstore"
    //   ? [
    //       {
    //         field: (item) =>
    //           item.issue?.rmpm_receive_status === 1 ? (
    //             item.issue?.production_status !== 1 ? (
    //               <Link
    //                 to={
    //                   role === "dstore"
    //                     ? `/production-generate/${item.issue.id}`
    //                     : `/production-generate/${item.issue.id}`
    //                 }
    //                 title={role === "Dstore" ? `Produce & Transfer` : `Produce`}
    //                 className="btn btn-info btn-sm"
    //               >
    //                 {role === "dstore" ? `Produce & Transfer` : `Produce`}
    //               </Link>
    //             ) : (
    //               <p className="btn btn-success btn-sm" title="Confirm">
    //                 <i className="fa fa-check"></i>
    //               </p>
    //             )
    //           ) : (
    //             ""
    //           ),
    //         header: "Produce",
    //       },
    //     ]
    //   : []),
    // ...(role === "mould" ||
    // role === "dstore" ||
    // role === "sagger" ||
    // role === "pstore"
    //   ? [
    //       {
    //         field: (item) =>
    //           item.issue?.rmpm_receive_status === 1 ? (
    //             item.issue?.production_status !== 1 ? (
    //               <Link
    //                 to={
    //                   role === "dstore"
    //                     ? `/production-generate/${item.issue.id}`
    //                     : `/production-generate/${item.issue.id}`
    //                 }
    //                 title={role === "Dstore" ? `Produce & Transfer` : `Produce`}
    //                 className="btn btn-info btn-sm"
    //               >
    //                 {role === "dstore" ? `Produce & Transfer` : `Produce`}
    //               </Link>
    //             ) : (
    //               <p className="btn btn-success btn-sm" title="Confirm">
    //                 <i className="fa fa-check"></i>
    //               </p>
    //             )
    //           ) : (
    //             ""
    //           ),
    //         header: "Produce",
    //       },
    //     ]
    //   : []),
    ...(role === "mould" ||
    role === "sagger" ||
    role === "dstore" ||
    role === "pstore"
      ? [
          {
            field: (item) => (
              <Link
                // to={`/production-generate/${item?.id}`}
                to={role === "dstore" ? `/production-generate-decals/${item?.id}` : role === "pstore" ? `/production-generate-packaging/${item?.id}` : `/production-generate/${item?.id}`}
                title={role === "dstore" ? `Produce & Transfer` : `Produce`}
                className="btn btn-info btn-sm"
              >
                {role === "dstore" ? `Produce & Transfer` : `Produce`}
              </Link>
            ),
          },
        ]
      : []),
  ];

  const actionTemplate = (item, deleteData) => {
    return (
      <td className="text-xs">
        <Link
          to={{
            pathname: "/show-department-requisition-jcg/" + item.id,
          }}
          className="btn btn-info btn-sm me-1"
          title="Show department requisition"
        >
          <i className="fa fa-list" aria-hidden="true"></i>
        </Link>
        {(role === "selection" || role === "dfw") &&
          (item.status === "requested" || item.status === "incomplete") && (
            <Link
              to={{
                pathname:
                  "/edit-delivery-jigcast-selection-approved/" + item.id,
              }}
              className="btn btn-success btn-sm"
              title="Edit delivery jigcast selection"
            >
              <i className="fa fa-plus-square" aria-hidden="true"></i>
            </Link>
          )}

        {item.requisition_production == null &&
          (role === "jigger" || role === "casting" || role === "gk") && (
            <></>
            // <Link
            //   to={{
            //     pathname: "/edit-department-requisition-jcg/" + item.id,
            //   }}
            //   className="btn btn-primary btn-sm mx-1"
            //   title="Edit department requisition jcg"
            // >
            //   <i className="fa fa-pencil" aria-hidden="true"></i>
            // </Link>
          )}
        {/* {item.issue === null &&
        (role === "gstore" || role === "pstore" || role === "dstore") ? (
          <Link
            to={{
              pathname: "/create-issue/" + item.id,
            }}
            className="btn btn-primary btn-sm ms-1"
          >
            <i className="fa fa-plus" aria-hidden="true"></i>
          </Link>
        ) : (
          ""
        )} */}
        {/* {(role === "mould" ||
          role === "sagger" ||
          role === "dstore" ||
          role === "pstore") &&
        item.requisition_production == null ? (
          <Link
            to={{
              pathname: "/create-requisition-production/" + item.id,
            }}
            className="btn btn-primary btn-sm ms-1"
            title="Create requisition production"
          >
            <i className="fa fa-plus-square" aria-hidden="true"></i>
          </Link>
        ) : (
          ""
        )} */}
        {(role === "mould" ||
          role === "sagger" ||
          role === "dstore" ||
          role === "pstore") &&
        item.requisition_production !== null ? (
          <Link
            to={{
              pathname:
                "/requisition-production-view/" +
                item.requisition_production.id,
            }}
            className="btn btn-warning btn-sm ms-1"
            title="Requisition production view"
          >
            <i className="fa fa-info-circle" aria-hidden="true"></i>
          </Link>
        ) : (
          ""
        )}

        {/* Check if role and created_by's user_type match */}
        {item.issue == null && item.created_by?.user_type === role ? (
          <>
            {/* <Link
              to={{
                pathname: "/edit-requisition-production/" + item.id,
              }}
              className="btn btn-secondary btn-sm ms-1"
            >
              <i className="fa fa-pencil" aria-hidden="true"></i>
            </Link>

            <button
              className="btn btn-danger btn-sm ms-1"
              onClick={() =>
                deleteData(
                  item.id,
                  "requisition-production",
                  "Requisition Production"
                )
              }
            >
              <i className="fa fa-trash"></i>
            </button> */}
          </>
        ) : (
          ""
        )}
      </td>
    );
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Departmental Requisition</h5>
            {role === "sample" && (
              <Link
                to="/create-sample-requisition"
                className="btn btn-primary"
                title="Create sample requisition"
              >
                <i className="fa fa-plus-square mg-r-6"></i> Add Sample
                Requisition
              </Link>
            )}
            {role !== "mould" &&
              role !== "dstore" &&
              role !== "pstore" &&
              role !== "selection" &&
              role !== "dfw" &&
              role !== "gstore" &&
              role !== "sample" && ( // Exclude 'sample' from the general link
                <Link
                  to="/create-department-requisition-jcg"
                  className="btn btn-primary"
                  title="Create department requisition jcg"
                >
                  <i className="fa fa-plus-square mg-r-6"></i> Add Requisition
                </Link>
              )}
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                actionTemplate={actionTemplate}
                deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
